module.exports = __webpack_public_path__ + "img/member_gt.2f41ea96.png";